<template>
  <div class="tag-search-result-list" data-scroll-element="true">
    <div class="tag-result-count-info" v-if="totalCount > 0">
      선택한 태그 {{getSectionText()}} 검색결과가 <span class="dark-purple">{{totalCount}}</span>건 있어요.
    </div>
    <div v-if="showEmptyList || totalCount === 0" class="empty-cell-list">
      <div class="attention-mark-area">
        <EmptyIcon />
      </div>
      <div class="text-area">
        선택한 태그 {{getSectionText()}} 검색결과가 없어요.<br/>
        다른 태그를 선택해보세요.
      </div>
    </div>
    <infinite-scroll-cell-list v-if="cellList && cellList.length"
                               key="infinite-scroll-cell-list-all-content-list"
                               :cell-list="cellList"
                               :thumbnail-info="thumbnailInfo"
                               :container-class-name="getCellListContainerClassName"
                               v-on:load-more="loadMore"></infinite-scroll-cell-list>
  </div>
</template>
<script>
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import { SearchService } from '@/common/api/api.service'
import { get } from 'lodash'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { mapGetters } from 'vuex'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'

export default {
  name: 'TagSearchResultList',
  props: ['type', 'totalCount'],
  components: {
    InfiniteScrollCellList,
    EmptyIcon
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      showEmptyList: false,
      endOfList: false,
      cellList: [],
      thumbnailInfo: {}
    }
  },
  methods: {
    getSectionText () {
      let res = ''
      switch (this.type) {
        case 'program':
          res = '프로그램'
          break
        case 'vod':
          res = '에피소드'
          break
        case 'movie':
          res = '영화'
          break
      }
      return res
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      let tagSearchList = []
      if (this.tagSearchFilterIndex !== null) {
        const tagList = Object.assign([], this.tagSearchKeywordList)
        tagSearchList = [tagList[this.tagSearchFilterIndex]]
      } else {
        tagSearchList = this.tagSearchKeywordList
      }
      SearchService.tagSearch({
        orderby: 'score',
        searchtags: tagSearchList,
        limit: this.limit,
        offset: this.offset,
        type: this.type
      }).then(({ data }) => {
        if (this.offset === 0) {
          this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
        }
        const resCellList = get(data, ['cell_toplist', 'celllist'], [])
        if (resCellList.length === 0) this.endOfList = true
        this.showEmptyList = this.cellList.length === 0 && resCellList.length === 0
        this.offset += this.limit
        this.cellList = this.cellList.concat(resCellList)
      })
    }
  },
  computed: {
    ...mapGetters(['tagSearchKeywordList', 'tagSearchFilterIndex']),
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    }
  },
  mounted () {
    if (this.totalCount === 0) {
      this.showEmptyList = true
    } else {
      this.setData()
    }
  }

}
</script>

<style scoped>
  .tag-search-result-list {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .tag-result-count-info {
    position: relative;
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    margin: 6px 0;
    color: #a5a5a5;
  }
  .empty-cell-list {
    position: relative;
    height: 250px;
    width: 100%;
    margin: 0 auto;
    top: 70px;
  }
  .empty-cell-list .attention-mark-area {
    height: 50px;
    width: 50px;
    position: relative;
    margin: 0 auto;
  }
  .empty-cell-list .text-area {
    text-align: center;
    margin-top: 16px;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 20px;
  }
</style>
